import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap justify-content-between align-items-center flex-1 gap-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-bold" }, "Nahrávanie príloh")
], -1)
const _hoisted_3 = { class: "flex gap-2" }
const _hoisted_4 = ["on:afterUploadFiles"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "pt-1 pb-1 flex flex-wrap gap-1" }
const _hoisted_7 = { class: "w-10" }
const _hoisted_8 = { class: "text-500 text-sm font-medium overflow-hidden text-overflow-ellipsis" }
const _hoisted_9 = { class: "text-400 text-xs" }
const _hoisted_10 = { class: "w-2 align-items-center flex" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center justify-content-center flex-column" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cloud-upload border-2 border-circle p-2 text-sm text-400 border-400" }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-400 mt-2 mb-0" }, "Potiahnutím sem pridáte súbory")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createBlock(_component_FileUpload, {
    name: "files[]",
    url: "",
    multiple: true,
    maxFileSize: 10000000,
    class: "border-solid border-1 surface-border",
    customUpload: true,
    onSelect: $options.onSelectedFiles
  }, {
    header: _withCtx(({ chooseCallback,clearCallback }) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_PrimevueButton, {
            class: "",
            label: "Vybrať súbory",
            disabled: false,
            severity: "success",
            icon: "pi pi-plus",
            raised: "",
            onClick: ($event: any) => (chooseCallback())
          }, null, 8, ["onClick"]),
          _createVNode(_component_PrimevueButton, {
            class: "",
            label: "Nahrať súbory",
            disabled: false,
            severity: "success",
            icon: "pi pi-upload",
            raised: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.uploadFiles()))
          })
        ])
      ]),
      _createElementVNode("div", {
        ref: "uploadDiv",
        "on:afterUploadFiles": ($event: any) => (clearCallback())
      }, null, 40, _hoisted_4)
    ]),
    content: _withCtx(({ files, removeFileCallback }) => [
      (files.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files, (file, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: file.name + file.type + file.size,
                  class: "shadow-2 p-1 flex surface-card w-10rem"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(file.name), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString($options.formattedFileSize(file.size)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_PrimevueButton, {
                      class: "file-danger",
                      icon: "pi pi-times",
                      onClick: ($event: any) => ($options.onRemoveTemplatingFile(file, removeFileCallback, index)),
                      severity: "danger"
                    }, null, 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    empty: _withCtx(() => [
      _hoisted_11
    ]),
    _: 1
  }, 8, ["onSelect"]))
}